import { register } from '../component.js';
import 'react';

var _socialIcons_facebook = register("facebook", {"color":"#3b5998","path":"M0 0v64h64V0zm39.6 22h-2.8c-2.2 0-2.6 1.1-2.6 2.6V28h5.3l-.7 5.3h-4.6V47h-5.5V33.3H24V28h4.6v-4c0-4.6 2.8-7 6.9-7 2 0 3.6.1 4.1.2z"});

export { _socialIcons_facebook as default };
